<script>
    import { push } from 'svelte-spa-router'
    import Hamburger from '../menu.svelte'

    import { fly } from 'svelte/transition'

    // npm から取ってくる
    import { onMount, onDestroy } from 'svelte';
    // この component（ Numbers.svelte ）が消えても　最後の y値 が消えないように stores 保存 
    import { y_last } from "../stores1"

    let y_value;

    // この component（ Numbers.svelte ）が消えるときに発動
    onDestroy(() => {
        // 最後の y値 を保存
        y_last.set(y_value)
    })

    // この component が現れるときに発動
    onMount(() => {
        // y値 を 最後の y値（= $y_last）と同じにする
        y_value = $y_last
    })

    var menu_counter = 0
        let menu_status = "off"

    const hamburger = () => {
        menu_counter++
        if (menu_counter % 1) {
            menu_status = "on"
        } else {
            menu_status = "off"
        }
    }

    import Policy from '../policy.svelte'
    import { policy } from '../stores6'

    const openPolicy = () => {
        policy.set(true)
    }

    import { nightmode } from "../stores5.js"
</script>

<div class:night={$nightmode} style="padding-left:8px;">
    <header class="header" transition:fly="{{x: 200}}">
        <div class="header-space1"></div>
        <div class="header-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="header-space2"></div>
    </header>
    <div class="catch">
        <div class="catch-item1" transition:fly="{{x: 200}}"></div>
        <div class="catch-item2" class:catch-item2-night={$nightmode} transition:fly="{{x: -200}}">開催概要</div>
    </div>
    <p style="font-size:20px; font-weight:700; color:red; margin:20px 0; margin-left:2%; width:85%;" transition:fly="{{x: 200}}">新型コロナウイルス感染症の感染拡大に際して、保護者を含む一般公開を中止することとしました。</p>
    <div class="detail date" transition:fly="{{x: -200}}">
        <div class="detail-item date-item" class:detail-item-night={$nightmode}>
            <div class="detail-item-title date-item-title">日時</div>
            <p>2021/09/18（土）10:00～17:00</p>
            <p>2021/09/19（日）10:00～17:00</p>
        </div>
    </div>
    <div class="detail place" transition:fly="{{x: -200}}">
        <div class="detail-item place-item" class:detail-item-night={$nightmode}>
            <div class="detail-item-title place-item-title">場所</div>
            <p class="place-item-p">東京都立西高等学校</p>
            <p class="place-item-adress">東京都杉並区宮前4-21-32</p>
        </div>
    </div>
    <div class="detail fee" transition:fly="{{x: -200}}">
        <div class="detail-item fee-item" class:detail-item-night={$nightmode}>
            <div class="detail-item-title fee-item-title">入場料</div>
            <p class="fee-item-p">完全予約制/無料</p>
            <p class="fee-item-p-small">会場内の「密集」「密接」を避けるため、完全予約制にて開催します。</p>
        </div>
    </div>
    <div class="detail attention" transition:fly="{{x: -200}}">
        <div class="detail-item attention-item" class:detail-item-night={$nightmode}>
            <div class="detail-item-title attention-item-title">新型コロナウイルス対策</div>
            <ul class="list1">
                <li>新型コロナウイルス感染症の感染拡大に際して、保護者を含む一般公開を中止することとしました。</li>
            </ul>
            <ul class="list2">
                <li>一般公開はせず、本校教職員・生徒のみで行います。該当しない方にはご来場頂けませんのでご注意下さい。</li>
                <li>保護者の方々、受験生の皆様、地域の皆様、西高卒業生をはじめとした一般客の皆様には「記念祭オンライン」を通じて記念祭参加団体のコンテンツをお楽しみ頂けます。詳細は追って連絡します。</li>
            </ul>
        </div>
    </div>
    <footer class="footer" transition:fly="{{x: -200}}">
        <div class="footer-title" on:click={() => push('/base1')}>第75回記念祭</div>
        <div class="policy" on:click={openPolicy}>プライバシーポリシー</div>
        <div class="footer-copyright">Copyright © 第75回記念祭 All Rights Reserved</div>
    </footer>
</div>

{#if menu_counter % 2 === 1}
<Hamburger/>
{/if}

{#if $policy}
<Policy/>
{/if}


<svelte:window bind:scrollY={y_value}/>

<style>
.night{
    background-color: #222831;
    color:#DDDDDD;
}
.header{
    display:flex;
    flex-wrap: wrap;
    width:100%;
}
.header-space1{
    flex-basis:44%;
}
.header-title{
    font-size:24px;
    font-weight: 400;
    text-align: right;
    letter-spacing: 5px;
    margin-top:16px;
    margin-bottom:16px;
    flex-basis:50%;
    font-family: 'Noto Sans JP';
    cursor: pointer;
}
.header-space2{
    flex-basis:6%;
}
.catch{
    position:relative;
    width:100%;
    height:580px;
    overflow: hidden;
}
.catch-item1{
    position:absolute;
    top:20px;
    right:-15px;
    width:80%;
    height:500px;
    background-image: url(/img/kinensai-pic-6.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 16% 50%;
    filter: saturate(0%);
    border-radius: 20px;
}
.catch-item2{
    display:table;
    background-color: greenyellow;
    position:absolute;
    top:500px;
    left:2%;
    font-size:40px;
    letter-spacing:.05em;
}
.catch-item2-night{
    color:#000000;
}
.detail{
    width:85%;
    margin-left:2%;
    padding:30px 0;
    border-bottom: 1px solid;
}
.detail-item-title{
    display:table;
    font-size:24px;
    margin-bottom:20px;
    background-color:greenyellow;
}
.detail-item-night div{
    color:#000000;
}
.date-item p{
    margin:10px 0 10px 0;
    font-size:20px;
}
.place-item-p{
    margin:10px 0 10px 0;
    font-size:20px;
}
.place-item-adress{
    font-size:16px;
    margin:10px 0 10px 0;
}
.fee-item-p{
    margin:10px 0 20px 0;
    font-size:20px;
}
.fee-item-p-small{
    line-height: 1.2em;
    margin:10px 0 10px 0;
    font-size:16px;
}
.attention-item{
    line-height: 1.2em;
}
.attention-item p{
    margin:30px 0 30px 0;
    font-size:18px;
    font-weight:700;
}
.list1{
    list-style-type: none;
    font-size:20px;
    font-weight:700;
    color:red;
    padding:0;
}
.list2{
    padding-left:20px;
    font-size:16px;
}
.list2 li{
    margin:10px 0;
}
.list3{
    padding-left:20px;
    list-style-type: none;
}
.list3 li{
    margin:10px 0;
    padding-left:10px;
    border-left:2px solid;
}
.footer{
    padding:40px 10px 40px 2%;
}
.footer-title{
    text-align: left;
    font-size:26px;
    font-weight:300;
    cursor: pointer;
}
.footer-copyright{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
}
.policy{
    text-align: left;
    font-size: 14px;
    font-weight: 300;
    margin:10px 0 0 0;
    cursor: pointer;
}
</style>